/** Shared feed card chrome (Mantine + CSS vars). */
export const FEED_CARD_HOVER = {
  transition: 'box-shadow 0.2s ease, transform 0.2s ease',
  '@media (min-width: 769px)': {
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-2px)'
    }
  }
} as const

export const FEED_ACTION_BAR_SX = {
  borderTop: '1px solid var(--gs-border)',
  backgroundColor: 'var(--gs-bg-2)',
  paddingTop: 8,
  paddingBottom: 8,
  paddingLeft: 12,
  paddingRight: 12
} as const
